import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=02d3b8a7&scoped=true&"
import script from "./Img.vue?vue&type=script&lang=ts&"
export * from "./Img.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d3b8a7",
  null
  
)

export default component.exports